import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';

export default function ManualEvidenceEditor({ 
  isOpen, 
  onClose, 
  onSave,
  initialData = { link: '', description: '', assessmentNotes: '', linkOptional: false }
}) {
  const [link, setLink] = React.useState(initialData.link || '');
  const [description, setDescription] = React.useState(initialData.description || '');
  const [assessmentNotes, setAssessmentNotes] = React.useState(initialData.assessmentNotes || '');
  const [linkOptional, setLinkOptional] = React.useState(initialData.linkOptional || false);

  // Update states when initialData changes
  React.useEffect(() => {
    setLink(initialData.link || '');
    setDescription(initialData.description || '');
    setAssessmentNotes(initialData.assessmentNotes || '');
    setLinkOptional(initialData.linkOptional || false);
  }, [initialData]);

  const handleSave = () => {
    onSave({ link, description, assessmentNotes, linkOptional });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div 
      style={{ 
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 100001,
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        border: '1px solid #ddd',
        minWidth: '400px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      }}
      onClick={e => e.stopPropagation()}
    >
      <h3 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: '600' }}>
        Manueller Nachweis
      </h3>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <label style={{ minWidth: '120px', fontSize: '14px', fontWeight: 'normal', textAlign: 'left' }}>
            <input
              type="checkbox"
              checked={linkOptional}
              onChange={e => setLinkOptional(e.target.checked)}
              style={{ marginRight: '8px' }}
            />
            kein Link vorhanden
          </label>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <label style={{ minWidth: '120px', fontSize: '14px', fontWeight: 'normal', textAlign: 'left' }}>
            Link:
          </label>
          <input
            type="url"
            value={link}
            onChange={e => setLink(e.target.value)}
            placeholder="https://example.com/link"
            style={{ 
              fontSize: '14px', 
              padding: '8px 12px', 
              flex: 1, 
              minWidth: '200px', 
              borderRadius: '6px', 
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.2s',
              opacity: linkOptional ? 0.6 : 1
            }}
            disabled={linkOptional}
            onFocus={e => e.target.style.borderColor = '#4caf50'}
            onBlur={e => e.target.style.borderColor = '#ccc'}
          />
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{ fontSize: '14px', fontWeight: 'normal' }}>
            Beschreibung:
          </label>
          <textarea
            value={description}
            onChange={e => setDescription(e.target.value)}
            placeholder="Beschreibung des manuellen Nachweises..."
            style={{ 
              fontSize: '14px', 
              padding: '8px 12px', 
              minHeight: '80px',
              resize: 'vertical',
              borderRadius: '6px', 
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.2s',
              fontFamily: 'inherit'
            }}
            onFocus={e => e.target.style.borderColor = '#4caf50'}
            onBlur={e => e.target.style.borderColor = '#ccc'}
          />
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <label style={{ fontSize: '14px', fontWeight: 'normal' }}>
            Beurteilungshinweise:
          </label>
          <textarea
            value={assessmentNotes}
            onChange={e => setAssessmentNotes(e.target.value)}
            placeholder="Hinweise zur Beurteilung dieses Nachweises..."
            style={{ 
              fontSize: '14px', 
              padding: '8px 12px', 
              minHeight: '80px',
              resize: 'vertical',
              borderRadius: '6px', 
              border: '1px solid #ccc',
              outline: 'none',
              transition: 'border-color 0.2s',
              fontFamily: 'inherit'
            }}
            onFocus={e => e.target.style.borderColor = '#4caf50'}
            onBlur={e => e.target.style.borderColor = '#ccc'}
          />
        </div>
      </div>
      
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #ddd' }}>
        <button
          style={{ 
            cursor: 'pointer', 
            color: 'white',
            backgroundColor: '#4caf50',
            border: 'none',
            padding: '10px 16px', 
            borderRadius: '6px', 
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.2s'
          }}
          onClick={handleSave}
          onMouseEnter={e => e.target.style.backgroundColor = '#45a049'}
          onMouseLeave={e => e.target.style.backgroundColor = '#4caf50'}
        >
          <FiCheck />
          Speichern
        </button>
        <button
          style={{ 
            cursor: 'pointer', 
            color: 'white',
            backgroundColor: '#f44336',
            border: 'none',
            padding: '10px 16px', 
            borderRadius: '6px', 
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'background-color 0.2s'
          }}
          onClick={onClose}
          onMouseEnter={e => e.target.style.backgroundColor = '#da190b'}
          onMouseLeave={e => e.target.style.backgroundColor = '#f44336'}
        >
          <FiX />
          Abbrechen
        </button>
      </div>
    </div>
  );
}
